import { AnnouncementViewComponent } from './announcement-view/announcement-view.component';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnnouncementsComponent } from './announcements.component';
import { AnnouncementEditComponent } from './announcement-edit/announcement-edit.component';
import { AuthGuard } from '../shared/auth/auth.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'announcements',
        canActivate: [AuthGuard],
        children: [
          { path: '', component: AnnouncementsComponent },
          { path: 'create', component: AnnouncementEditComponent },
          {
            path: ':id',
            children: [
              {
                path: '',
                component: AnnouncementsComponent
              },
              {
                path: 'update',
                component: AnnouncementEditComponent
              },
              {
                path: 'view',
                component: AnnouncementViewComponent
              }
            ]
          }
        ]
      },
    ])
  ],
  exports: [RouterModule]
})
export class AnnouncementsRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/announcements-routing.module.ts